module.exports = __webpack_public_path__ + "static/media/img.64bf606a.svg";